import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const AUDIT_PERMISSIONS = {
  READ: PERMISSIONS.AUDIT_READ,
};

export const AUDIT_QUERY_KEYS = queryKeys.audit;
